var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.error)?_c('p',{staticClass:"error--text mt-1",style:(_vm.errorMessageStyles)},[_vm._v("\n  "+_vm._s(_vm.error)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }